import { planExportedAnalytics } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/export-roadmap/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapStateToProps from './query.tsx';
import PngExport from './view.tsx';

export default connect(mapStateToProps, {
	planExportedAnalytics,
})(PngExport);
